export default __webpack_public_path__ + "4d146be508213399a8c3187751dc7fbb.svg";